<template>
    <div class="cguContent">
        <div class="mainTitle">
            CONDITIONS GÉNÉRALES D’UTILISATION <br /> DE LA PLATEFORME SPOMO 
            <br />(Version Bêta-Test) 
        </div>

        <div v-if="cgu">
            <div v-for="(article,id) in cgu.articles" :key="id">
                <div class="articleTitle">{{ article.title }}</div>
                <div class="articleContent" v-if="article.content">
                    <p v-html="article.content"></p>
                </div>
                <div v-if="article.subArticle">
                    <div v-for="(subArticle,id) in article.subArticle" :key="id">
                        <div class="articleSubTitle">{{ subArticle.title }}</div>
                        <div class="articleContent">
                            <p v-html="subArticle.content"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            cgu:null
        }
    },
    mounted(){
        this.cgu = require('./cgu_fr.json');
    }
}
</script>

<style scpoed>

.cguContent {
    padding-left: 3%;
    padding-right: 3%;
}

.mainTitle {
  font-family: Comfortaa;
  font-style: normal;
  font-weight: bold;
  font-size: 23px;
  text-align: center;
  color: #068BB2;
  padding-bottom: 25px;
}

.articleTitle {
  font-family: Comfortaa;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #068BB2;
  padding-bottom: 10px;
}

.articleSubTitle {
    font-family: Comfortaa;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    /* color: #068BB2; */
    padding-left: 5%;
    padding-bottom: 10px;
}

.articleContent {
    padding-bottom: 20px;
}


</style>